"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPricingModelUpdateInputSchema = exports.APosPricingModelCreateInputSchema = exports.APosPricingModelSchema = exports.APosPriceEndingSchema = exports.APosPricingRoundBaseSchema = exports.APosPricingModelOperationSchema = exports.APosPricingModelBaseSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosPricingModelBaseSchema = zod_1.z.enum(['cost', 'retail', 'online', 'wholesale']);
exports.APosPricingModelOperationSchema = zod_1.z.enum([
    'multiply',
    'add_fixed',
    'add_percent',
    'subtract_fixed',
    'subtract_percent',
]);
exports.APosPricingRoundBaseSchema = zod_1.z.enum(['none', 'nearest_1', 'nearest_5', 'nearest_10']);
exports.APosPriceEndingSchema = zod_1.z.enum(['none', 'dot_99', 'dot_95', 'dot_00']);
exports.APosPricingModelSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    pricingModelId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    base: exports.APosPricingModelBaseSchema,
    operation: exports.APosPricingModelOperationSchema,
    value: zod_1.z.number().positive(),
    roundBase: exports.APosPricingRoundBaseSchema.default('none'),
    priceEnding: exports.APosPriceEndingSchema.default('none'),
    autoAdjust: zod_1.z.boolean().default(true),
    basePriceRequired: zod_1.z.boolean().default(false),
    status: zod_1.z.enum(['active', 'inactive']).default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosPricingModelCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    base: exports.APosPricingModelBaseSchema,
    operation: exports.APosPricingModelOperationSchema,
    value: zod_1.z.number().positive(),
    roundBase: exports.APosPricingRoundBaseSchema.optional(),
    priceEnding: exports.APosPriceEndingSchema.optional(),
    autoAdjust: zod_1.z.boolean().optional(),
    basePriceRequired: zod_1.z.boolean().optional(),
});
exports.APosPricingModelUpdateInputSchema = exports.APosPricingModelCreateInputSchema.partial().extend({
    status: zod_1.z.enum(['active', 'inactive']).optional(),
});
//# sourceMappingURL=pricing-model.schema.js.map